import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const WhatsAppButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);
  const whatsappGroupLink = "https://chat.whatsapp.com/C5Mc0ApWSCVJYRNDMq6dOe";
  const location = useLocation();

  // Auto-hide on scroll down, show on scroll up
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show if at top of page
      if (currentScrollY < 50) {
        setIsVisible(true);
      }
      // Hide when scrolling down, show when scrolling up
      else if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY.current) {
        setIsVisible(true);
      }
      
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Hide button in admin areas
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  const handleJoinGroup = () => {
    window.open(whatsappGroupLink, "_blank", "noopener,noreferrer");
  };

  return (
    <div 
      className={`fixed bottom-4 right-4 z-50 group transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0 pointer-events-none'
      }`}
    >
      {/* Tooltip - Desktop Only */}
      <div className="
        hidden md:block
        absolute bottom-full right-0 mb-3
        px-3 py-2 bg-cream text-night text-sm font-medium rounded-lg
        shadow-xl whitespace-nowrap
        transition-all duration-200 ease-out
        opacity-0 translate-y-1 pointer-events-none
        group-hover:opacity-100 group-hover:translate-y-0
      ">
        Join our WhatsApp
        <div className="absolute top-full right-4 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-transparent border-t-cream"></div>
      </div>

      {/* Main Button - Small and elegant */}
      <button
        onClick={handleJoinGroup}
        className="
          relative
          bg-gold hover:bg-gold-light
          text-night
          rounded-full
          p-3
          shadow-lg
          transition-[background-color,transform] duration-150 ease-out
          active:scale-95
        "
        aria-label="Join our WhatsApp group"
      >
        {/* WhatsApp Icon */}
        <svg
          className="w-6 h-6 relative z-10"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
        </button>
    </div>
  );
};

export default WhatsAppButton;